const state = {
    supplier: null,
    supplierId: undefined,
    marketPlaceProductType: undefined,
    transactionAmount: undefined,
    routPath: '',
    method: '',
    transactionID: undefined,
    invoiceNumber: undefined,
    uploadedDocument: [],
    showSidebar: false,
    paymentMethod: [],
};
export default state;
